<template>
    <v-popover offset="0" :open="isOpen" trigger="manual" :autoHide="false">
        <button class="tooltip-target btn btn-sm btn-link" @click="open" :data-testid="'reception-visit-doctor-' + visitId"><i class="fa fa-exchange" aria-hidden="true"></i></button>
        <template slot="popover">
    <div class="container">
        <div class="row">
            <div class="col-sm-12"><h3>změna doktora</h3></div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <template v-for="doctor in doctors">
                    <button class="btn btn-primary m-1"  v-if="doctor.id !== selectedDoctorId" @click="changeDoctor(doctor.id)" :data-testid="'reception-visit-doctor-option-' + visitId + '-' + doctor.id">{{ doctor.fullname }}</button>
                    <button class="btn btn-primary disabled m-1"  disabled="disabled" v-else="">{{ doctor.fullname }}</button>
                </template>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <button class="btn btn-sm btn-outline-danger mt-3" @click="close">zavřít</button>
            </div>
        </div>
    </div>
    </template>
    </v-popover>
</template>

<script>
  export default {
    data () {
      return {
        changePending: false,
        changeError: null,
        visit: {},
        isOpen: false
      }
    },
    props: ['doctors', 'selectedDoctorId', 'visitId'],
    methods: {
      changeDoctor (doctorId) {
        this.changePending = true
        this.visit.planned_for = doctorId
        this.$http.put('visit/' + this.visitId, this.visit, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.changePending = false
          this.$emit('update')
          this.close()
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.changeError = error.response.data.errors
          this.changePending = false
        })
      },
      open () {
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      }
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }

    /*modal insurance*/

    tr.valid_line {
        font-weight: bold;
    }

    .modal_default {
        overflow: visible !important;
    }

    table.table td {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/HomeReceptionist/components/VisitChangeDoctor.vue?868dd886